import { util } from '@tencent/ppd-base-libs';
import { CustomException } from '@/utils/error';
import { redirectLogin } from '@/business/login';
import request, { BaseResp } from './base';
import { getParameterByName } from '@/utils';

/**
 * getScheme不可重试错误码
 * 043 表解密失败
 * 007 表解密成功，但未生成过此加密串（007的场景比较极端，很少出现）
 * 011 参数错误 这个是a为空，或者is inside wx不是数字
 * 001 is inside wx非0和1的错
*/
export const GET_SCHEME_ERR_CODE_ARR = [1613926043, 1610927007, 1613926011, 1610927001];

/**
 * 是否在端内打开
 * 0 - 在端外打开
 * 1 - 在端内打开
 */
export enum IsInsideWx {
  NO = '0', // 端外打开
  YES = '1',  // 端内打开
}

/**
 * scheme码生成是否超限
 * 0 - 未达上限
 * 1 - 已达到业务上限
 * 2 - 达到总量上限
 * 2022年5月19号注：当前产品上没有对超过业务上限和总量上限作异化处理
*/
export enum HasReachLimit {
  IN_LIMIT = 0, // 未达上限
  OUT_BUSI_LIMIT = 1,  // 已达到业务上限
  OUT_TOTAL_LIMIT = 2 // 达到总量上限（指达到了每个小程序每天50万的上限）
}

/**
 * 业务类型
*/
export enum BusiType{
  WE_REMIT_GPC = 'we_remit_gpc',  // 小鹅快收
  WE_TUITION = 'we_tuition',  // 留学缴费
  WE_REMIT_GC = 'we_remit_gc' // 全球汇入
}

// 后台接口业务场景枚举值
export enum BusiSceneEnum{
  REMITTER = '1'  // 汇款人视角
}

/**
 * 业务附加信息，仅在中转页使用
*/
export interface BusiInfo{

  // 汇款人文字链情况，将附带收款人链接信息
  receiverUrl?: string

  // 具体的业务场景
  busiScene?: BusiSceneEnum
}

export enum WxOpenapi{
  qrcode = 1
}

/**
 * 场景
*/
export enum SceneType{
  SMS = 1,  // 短信
  MARKETING = 2 // 营销推广
}

export interface WxOpenapiResp extends BaseResp {
  wx_openapi_res: string
}

export interface SchemeResp extends BaseResp {
  scheme: string; // scheme码原文，非空
  path: string; // 从微信打开的跳转url，非空
  query_param: {  // 小程序内查询query参数机构体，非空
    [propName: string]: any; // 小程序带入的参数
  };

  /**
   * 埋点上报用的字段
   * 会传给小程序作上报用，也可以用在中转页上报
  */
  bihottag?: {
    [propName: string]: any;
  };

  has_reach_limit: HasReachLimit;  // scheme码生成是否超限，非空
  busi_type: BusiType;  // 业务类型，非空
  scene_type: SceneType; // 场景，非空

  busi_info?: BusiInfo
}

// 前端带入加密串,后端解密并返回scheme和query和path
export async function queryGetScheme(encryptedInfo: string, isInsideWx: IsInsideWx): Promise<SchemeResp> {
  return request.post('util/get_scheme.fcgi', {
    // 加密串
    a: encryptedInfo,
    // 是否端内打开
    is_inside_wx: isInsideWx,
  });
}

// 使用加密串请求微信开发cgi
export async function queryWxOpencgi(
  encryptedInfo: string,
  wxOpenapiType: WxOpenapi,
  path: string,
): Promise<WxOpenapiResp> {
  return request.post('util/get_wx_openapi.fcgi', {
    // 加密串
    scene: encryptedInfo,
    // 是否端内打开
    wx_openapi_type: wxOpenapiType,
    path,
  });
}

// Jsapi返回值结构
export interface JsapiResp extends BaseResp {
  wx_config: {
    appId: string,
    timeStamp: string,
    nonceStr: string,
    signature: string,
  }; // 包含JSSDK初始化设置所需的四个参数：appId、timeStamp、nonceStr、signature
}

// 公众号获取jsapi签名接口
export async function getJsapiParam(url: string): Promise<JsapiResp> {
  return request.get('remit_gpc/query_jsapi_param.fcgi', {
    params: {
      // 重定向url
      url,
    },
  });
}

// 公众号登录接口
export async function accLogin(code: string): Promise<BaseResp> {
  return request.get('remitgc/we_remit_gc_official_acc_login.fcgi', {
    params: {
      // 微信服务器返回code
      code,
    },
  });
}

// 登录公众号
export async function login() {
  const code = getParameterByName('code');
  if (!code) {
    redirectLogin('wx7c6120c7a4c2ed5d');
    return;
  }
  // 公众号登录
  const [err] = await util.to(accLogin(code));
  if (err) {
    throw new CustomException(err, 'AccLoginFailed', '公众号登录失败');
  }
}

